export default "__VITE_ASSET__FO2VY_0i__"